export default "__VITE_ASSET__D_H2BQz0__"